// extracted by mini-css-extract-plugin
module.exports = {"title":"GameTitle_title__hqIV2"};